import { settingsStore } from "../stores/settings";
import { sessionStore } from "../stores/session";
import { get } from "svelte/store";
import { hasInvalidChannel } from "../routing";
import PATHS from "../constants/routePaths";
import { navigateToPath } from "../routing";
import { decodeJWT } from "../public/lib/helpers/jwt";
import { getSearchParam } from "./document";

const getFoojiData = () => {
  const jwt = getSearchParam("jwt");

  if (jwt) {
    try {
      const decodedJWT = decodeJWT(jwt);

    if (decodedJWT.is_temp) {
        return decodedJWT.temp_data?.fooji_data;
      }
    } catch (error) {
      console.error("Error getting fooji data", error);
    }
  }

  return get(sessionStore).foojiData;
};

export const checkLandingSession = () => {
  // I assume that an exchange JWT has priority over the session store...
  if (hasInvalidChannel(get(settingsStore).channels, getFoojiData())) {
    navigateToPath(get(sessionStore).isExpired ? PATHS.LINK_EXPIRED : PATHS.INVALID_CHANNEL);
    throw new Error("Invalid channel");
  }
};
